import ListLoadController from "./list_load_controller";

export default class extends ListLoadController {
  initialize() {
    this.startUpdating();
  }

  disconnect() {
    this.stopUpdating();
  }

  startUpdating() {
    this.loadList();
    this.updateInterval = setInterval(() => {
      this.loadList();
    }, 10 * 1000);
  }

  stopUpdating() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
  }

  loadList() {
    this.fetchForTarget(window.App.prefixedUrl(`/alarms/list?${this.paramsString()}`), this.listTarget)
      .then(() => {
        App.$iconify.scanDOM();
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  paramsString() {
    return new URLSearchParams(window.location.search).toString();
  }
}